import cls from "./maintenance.module.scss"
import React, {FC} from "react";
import CountDown from "./CountDown";
import {IMaintenanceInfo} from "../../pages/maintenance";
import {domainUrl} from "../../helper";
interface IProps {
    dbName: string;
    maintenanceInfo: IMaintenanceInfo;
    whiteLogoPath: string;
    cacheControlVersion: string
}

const Maintenance: FC<IProps> = (
    {
        dbName,
        maintenanceInfo,
        cacheControlVersion,
        whiteLogoPath
    }
) => {
    return (
        <div className={cls.main}>
            <div className={cls.logo_wrapper}>
                <div className={cls.logo_div}>
                    <img
                        src={domainUrl(`${dbName}/${whiteLogoPath}?v=${cacheControlVersion}`)}
                        alt="Logo"
                        loading="eager"
                        width="200"
                        height="40"
                    />
                </div>
            </div>
            <div className={cls.contentCentered}>
                <div className={cls.content}>
                    <h2>{maintenanceInfo.maintenance_mode_text}</h2>
                    <h1>COMING SOON</h1>
                    <CountDown endDate={maintenanceInfo.maintenance_mode_end_date}/>
                </div>
            </div>
        </div>
    )
};

export default Maintenance;
